import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {
  
  transform(value: any, pattern:any, replacement: any): any {
    if (value && typeof value === 'string') {
      return value.split(pattern).join(replacement);
    } else {
      return value;
    }
    
  }

}
